import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useCurrency } from '../contexts/CurrencyContext';
import { translations } from '../translations';
import LanguageSwitcher from '../components/LanguageSwitcher';
import CurrencySwitcher from '../components/CurrencySwitcher';
import DatePicker from 'react-datepicker';
import Footer from '../components/Footer';
import 'react-datepicker/dist/react-datepicker.css';
import 'flag-icons/css/flag-icons.min.css';

const MainPage = () => {
  const { language } = useLanguage();
  const { formatPrice, getPriceSuffix, getCurrencySymbol } = useCurrency();
  const t = translations[language];
  const navigate = useNavigate();

  const [selectedType, setSelectedType] = useState('all');
  const [sortBy, setSortBy] = useState('default');

  const [bookingData, setBookingData] = useState({
    name: '',
    email: '',
    phone: '',
    bikeId: '',
    startDate: null,
    endDate: null,
    location: 'phuket'
  });

  // Реалистичные цены в THB (тайских батах) с красивыми округленными значениями
  const bikes = [
    // Scooters - экономичные (цена в THB)
    { id: 1, name: 'Honda Click 125i', type: 'scooter', price: 300, image: 'https://motorbike-bohol.com/wp-content/uploads/2022/02/Goodbike-Motorbike-Rental-Panglao-Bohol-Honda-Click-125i-Red-Right2-scaled.webp', popular: true, engine: '125cc', capacity: '2 persons', descKey: 'bikeDesc1' },
    { id: 2, name: 'Yamaha Fino 125', type: 'scooter', price: 280, image: 'https://avatars.mds.yandex.net/get-autoru-vos/1932996/7ee4759ab89293d6f851af56bdabbf10/456x342', popular: false, engine: '125cc', capacity: '2 persons', descKey: 'bikeDesc2' },
    { id: 3, name: 'Honda Scoopy 110', type: 'scooter', price: 250, image: 'https://www.shutterstock.com/image-photo/sidoarjo-indonesia-february-07-2025-260nw-2583537531.jpg', popular: true, engine: '110cc', capacity: '2 persons', descKey: 'bikeDesc3' },
    
    // Scooters - средний класс
    { id: 4, name: 'Honda PCX 160', type: 'scooter', price: 500, image: 'https://avcdn.av.by/advertmedium/0007/0485/9633.jpg', popular: true, engine: '160cc', capacity: '2 persons', descKey: 'bikeDesc4' },
    { id: 5, name: 'Yamaha NMAX 155', type: 'scooter', price: 550, image: 'https://www.moto-market.ru/sadm_images/zemlya-asfalt-sneg/094c51f9aaf0284de7ddbf124455333d.jpg', popular: true, engine: '155cc', capacity: '2 persons', descKey: 'bikeDesc5' },
    { id: 6, name: 'Yamaha Aerox 155', type: 'scooter', price: 600, image: 'https://ru.thai-moto.com/images/transport/d74bbfdbb3cc4663cf715e871d2a4638.jpeg', popular: false, engine: '155cc', capacity: '2 persons', descKey: 'bikeDesc6' },
    
    // Scooters - премиум
    { id: 7, name: 'Honda ADV 150', type: 'scooter', price: 700, image: 'https://phuket4you.ru/wp-content/uploads/2023/08/Honda-ADV150-2022-%D1%84%D0%BE%D1%82%D0%BE-1.jpg', popular: false, engine: '150cc', capacity: '2 persons', descKey: 'bikeDesc7' },
    { id: 8, name: 'Vespa Sprint 150', type: 'scooter', price: 900, image: 'https://avatars.mds.yandex.net/get-autoru-vos/5635384/84f9311e243a182910a1361e8ebb6db5/456x342', popular: false, engine: '150cc', capacity: '2 persons', descKey: 'bikeDesc8' },
    { id: 9, name: 'Honda Forza 350', type: 'scooter', price: 1200, image: 'https://www.honda-moto.lv/files/a2024/20240815_194034.jpg', popular: true, engine: '350cc', capacity: '2 persons', descKey: 'bikeDesc9' },
    { id: 10, name: 'Yamaha XMAX 300', type: 'scooter', price: 1300, image: 'https://vcdn1-vnexpress.vnecdn.net/2025/05/31/Yamaha-Xmax-300-2025-VnE-18045-2857-6543-1748708091.jpg?w=500&h=300&q=100&dpr=1&fit=crop&s=JEptCFBkr_MIDlrAZCbEiw', popular: true, engine: '300cc', capacity: '2 persons', descKey: 'bikeDesc10' },
    
    // Motorcycles - начальный класс
    { id: 11, name: 'Honda CB300R', type: 'motorbike', price: 800, image: 'https://i0.wp.com/motofoodie.in/wp-content/uploads/2022/05/2022-honda-cb300r-women-friendly-motorcycle-in-india.jpg?ssl=1', popular: true, engine: '300cc', capacity: '2 persons', descKey: 'bikeDesc11' },
    { id: 12, name: 'Kawasaki Z400', type: 'motorbike', price: 900, image: 'https://avatars.mds.yandex.net/get-autoru-vos/1992394/5d58499ca773281653f34fdeae5bb458/456x342', popular: false, engine: '400cc', capacity: '2 persons', descKey: 'bikeDesc12' },
    { id: 13, name: 'Suzuki V-Strom 250', type: 'motorbike', price: 750, image: 'https://carupdater.com/carlibrary/courtesybikes/large/999761016_6.jpg', popular: true, engine: '250cc', capacity: '2 persons', descKey: 'bikeDesc13' },
    
    // Motorcycles - средний класс
    { id: 14, name: 'Kawasaki Ninja 400', type: 'motorbike', price: 1500, image: 'https://90.img.avito.st/image/1/1.Wgr7d7aA9uON2TTsw1YbT5jW9OdJwPLjSaeX50kU-SFA1PL5jdk07E0.JNqfTHExHkQPT7V3G6BdWyd_M1--UI-bsISi-unH12g', popular: true, engine: '400cc', capacity: '2 persons', descKey: 'bikeDesc14' },
    { id: 15, name: 'Honda CRF300L', type: 'motorbike', price: 1000, image: 'https://avatars.mds.yandex.net/get-autoru-vos/17394937/00fb321c45c889e49c010977e4e000b4/456x342', popular: false, engine: '300cc', capacity: '1 person', descKey: 'bikeDesc15' },
    { id: 16, name: 'BMW G310R', type: 'motorbike', price: 1100, image: 'https://img.motopodbor.com/content/15/dd/6af6904810a3602cd4f78d25d42a.jpg', popular: true, engine: '310cc', capacity: '2 persons', descKey: 'bikeDesc16' },
    
    // Motorcycles - премиум класс
    { id: 17, name: 'Royal Enfield Himalayan 450', type: 'motorbike', price: 1200, image: 'https://static.insales-cdn.com/images/products/1/5612/933803500/2.jpeg', popular: false, engine: '450cc', capacity: '2 persons', descKey: 'bikeDesc17' },
    { id: 18, name: 'Ducati Scrambler Icon', type: 'motorbike', price: 2500, image: 'https://cdpcdn.dx1app.com/products-private/prod/c6051416-2084-49d3-ad62-81fc423aa561/39488952-0bf2-433f-84dd-66d5846103a8/00000000-0000-0000-0000-000000000000/e2813dee-8aae-4f5d-b413-b20a004d4300/4afbfec3-6f5b-48cb-adad-b2d8015fb6c3/6000000014.jpg', popular: true, engine: '800cc', capacity: '2 persons', descKey: 'bikeDesc18' },
    { id: 19, name: 'Harley-Davidson Street 750', type: 'motorbike', price: 3000, image: 'https://img-fotki.yandex.ru/get/6609/21859884.0/0_1a399b_50e1fa85_XL.jpg', popular: false, engine: '750cc', capacity: '2 persons', descKey: 'bikeDesc19' },
    { id: 20, name: 'Triumph Tiger 900', type: 'motorbike', price: 3500, image: 'https://avatars.mds.yandex.net/get-autoru-vos/16019815/6a717050e7816556e61d11a6d67b0e9c/456x342', popular: true, engine: '900cc', capacity: '2 persons', descKey: 'bikeDesc20' }
  ];

  const locations = [
    { id: 'phuket', name: 'Phuket', deliveryKey: 'deliveryPhuket' },
    { id: 'bangkok', name: 'Bangkok', deliveryKey: 'deliveryBangkok' },
    { id: 'chiangmai', name: 'Chiang Mai', deliveryKey: 'deliveryChiangmai' },
    { id: 'krabi', name: 'Krabi', deliveryKey: 'deliveryKrabi' },
    { id: 'pattaya', name: 'Pattaya', deliveryKey: 'deliveryPattaya' },
    { id: 'samui', name: 'Koh Samui', deliveryKey: 'deliverySamui' }
  ];

  const filteredBikes = selectedType === 'all'
    ? bikes
    : bikes.filter(bike => bike.type === selectedType);

  const sortedBikes = [...filteredBikes].sort((a, b) => {
    switch (sortBy) {
      case 'price-low': return a.price - b.price;
      case 'price-high': return b.price - a.price;
      case 'name': return a.name.localeCompare(b.name);
      default: return 0;
    }
  });

  const handleBookingChange = (e) => {
    const { name, value } = e.target;
    setBookingData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setBookingData(prev => ({
      ...prev,
      startDate: start,
      endDate: end
    }));
  };

  const calculateDays = () => {
    if (!bookingData.startDate || !bookingData.endDate) return 0;
    const diffTime = Math.abs(bookingData.endDate - bookingData.startDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  };

  const getSelectedBike = () => {
    return bikes.find(bike => bike.id === parseInt(bookingData.bikeId));
  };

  const calculateTotal = () => {
    const selectedBike = getSelectedBike();
    if (!selectedBike) return 0;
    const days = calculateDays();
    return selectedBike.price * days;
  };

  const handleSubmitBooking = (e) => {
    e.preventDefault();

    const selectedBike = getSelectedBike();
    const days = calculateDays();
    const total = calculateTotal();

    if (!selectedBike || days === 0) {
      alert(t.selectBikeDates || 'Please select a bike and dates');
      return;
    }

    // Сохраняем данные в localStorage для передачи на страницу счета
    localStorage.setItem('bookingData', JSON.stringify({
      ...bookingData,
      bike: selectedBike,
      days: days,
      subtotal: total,
      currency: getCurrencySymbol()
    }));

    // Переходим на страницу счета
    navigate('/invoice');
  };

  const selectBikeForBooking = (bikeId) => {
    setBookingData(prev => ({
      ...prev,
      bikeId: bikeId.toString()
    }));
    document.getElementById('booking-form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon">🏍️</span>
            <h1>ThaiBike Rent</h1>
          </div>

          <nav className="nav">
            <a href="#bikes">{t.navBikes}</a>
            <a href="#booking">{t.navBooking}</a>
            <a href="#locations">{t.navLocations}</a>
            <a href="#contacts">{t.navContact}</a>
          </nav>

          <div className="header-right">
            <LanguageSwitcher />
            <CurrencySwitcher />
            <div className="contact-header">
              <a href="tel:+66615539384" className="phone">+66 61 553 93 84</a>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h2>{t.heroTitle}</h2>
            <p>{t.heroSubtitle}</p>
            <div className="hero-buttons">
              <a href="#bikes" className="btn btn-primary">{t.heroButton1}</a>
              <a href="#booking" className="btn btn-secondary">{t.heroButton2}</a>
            </div>
            <div className="currency-notice">
              <span className="currency-icon">💱</span>
              {t.currencyNotice}
            </div>
          </div>
        </div>
      </section>

      {/* Bike Catalog */}
      <section id="bikes" className="bikes-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{t.catalogTitle}</h2>
            <div className="currency-display">
              <span className="currency-label">{t.displayPricesIn}</span>
              <span className="currency-active">{getCurrencySymbol()}</span>
            </div>
          </div>

          {/* Filter and Sort Controls */}
          <div className="controls-row">
            <div className="filter-buttons">
              <button
                className={`filter-btn ${selectedType === 'all' ? 'active' : ''}`}
                onClick={() => setSelectedType('all')}
              >
                {t.filterAll}
              </button>
              <button
                className={`filter-btn ${selectedType === 'scooter' ? 'active' : ''}`}
                onClick={() => setSelectedType('scooter')}
              >
                {t.filterScooters}
              </button>
              <button
                className={`filter-btn ${selectedType === 'motorbike' ? 'active' : ''}`}
                onClick={() => setSelectedType('motorbike')}
              >
                {t.filterMotorcycles}
              </button>
            </div>

            <div className="sort-options">
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="sort-select"
              >
                <option value="default">{t.sortBy || 'Sort by'}</option>
                <option value="price-low">{t.sortPriceLow || 'Price: Low to High'}</option>
                <option value="price-high">{t.sortPriceHigh || 'Price: High to Low'}</option>
                <option value="name">{t.sortName || 'Name A-Z'}</option>
              </select>
            </div>
          </div>

          {/* Bike Grid */}
          <div className="bike-grid">
            {sortedBikes.map(bike => (
              <div key={bike.id} className="bike-card">
                {bike.popular && <span className="popular-badge">{t.popularBadge}</span>}
                <div className="bike-image" style={{ backgroundImage: `url(${bike.image})` }}></div>
                <div className="bike-info">
                  <h3>{bike.name}</h3>
                  <div className="bike-specs">
                    <span className="bike-engine">⛽ {bike.engine}</span>
                    <span className="bike-capacity">👥 {bike.capacity}</span>
                  </div>
                  <p className="bike-description">{t[bike.descKey] || bike.description}</p>
                  <div className="bike-details">
                    <span className="bike-type">
                      {bike.type === 'scooter' ? t.filterScooters : t.filterMotorcycles}
                    </span>
                    <span className="bike-price">
                      {formatPrice(bike.price)} {getPriceSuffix()}
                    </span>
                  </div>
                  <button
                    className="btn btn-small"
                    onClick={() => selectBikeForBooking(bike.id)}
                  >
                    {t.bookButton}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking Form */}
      <section id="booking" className="booking-section">
        <div className="container">
          <h2 className="section-title" id="booking-form">{t.bookingTitle}</h2>

          {/* Price Calculator Preview */}
          {bookingData.bikeId && (
            <div className="price-preview">
              <h3>{t.priceSummary || 'Price Summary'}</h3>
              <div className="price-details">
                <p>{t.selected || 'Selected'}: <strong>{getSelectedBike()?.name}</strong></p>
                <p>{t.dailyRate || 'Daily Rate'}: <strong>{formatPrice(getSelectedBike()?.price)}</strong></p>
                <p>{t.days || 'Days'}: <strong>{calculateDays()}</strong></p>
                <p className="total">{t.subtotal || 'Subtotal'}: <strong>{formatPrice(calculateTotal())}</strong></p>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmitBooking} className="booking-form">
            <div className="form-row">
              <div className="form-group">
                <label>{t.formName}</label>
                <input
                  type="text"
                  name="name"
                  value={bookingData.name}
                  onChange={handleBookingChange}
                  required
                  placeholder="John Doe"
                />
              </div>
              <div className="form-group">
                <label>{t.formEmail}</label>
                <input
                  type="email"
                  name="email"
                  value={bookingData.email}
                  onChange={handleBookingChange}
                  required
                  placeholder="john@example.com"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>{t.formPhone}</label>
                <input
                  type="tel"
                  name="phone"
                  value={bookingData.phone}
                  onChange={handleBookingChange}
                  required
                  placeholder="+66 123 456 789"
                />
              </div>
              <div className="form-group">
                <label>{t.formBike}</label>
                <select
                  name="bikeId"
                  value={bookingData.bikeId}
                  onChange={handleBookingChange}
                  required
                >
                  <option value="">{t.formBike || 'Select Vehicle'}</option>
                  {bikes.map(bike => (
                    <option key={bike.id} value={bike.id}>
                      {bike.name} - {formatPrice(bike.price)}/day
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group date-picker-group">
                <label>{t.selectDates || 'Select Rental Dates *'}</label>
                <DatePicker
                  selected={bookingData.startDate}
                  onChange={handleDateChange}
                  startDate={bookingData.startDate}
                  endDate={bookingData.endDate}
                  selectsRange
                  minDate={new Date()}
                  placeholderText={t.datePlaceholder || 'Select start and end date'}
                  className="date-picker-input"
                  required
                />
              </div>
              <div className="form-group">
                <label>{t.formLocation}</label>
                <select
                  name="location"
                  value={bookingData.location}
                  onChange={handleBookingChange}
                  required
                >
                  {locations.map(loc => (
                    <option key={loc.id} value={loc.id}>
                      {loc.name} - {t[loc.deliveryKey] || 'Delivery available'}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>{t.formNotes}</label>
              <textarea
                name="notes"
                onChange={handleBookingChange}
                placeholder={language === 'en' ? "Child equipment needed, special requirements, etc." : 
                           language === 'de' ? "Kinderausrüstung benötigt, besondere Anforderungen, usw." :
                           language === 'fr' ? "Équipement pour enfant nécessaire, demandes spéciales, etc." :
                           language === 'it' ? "Attrezzatura per bambini necessaria, richieste speciali, ecc." :
                           language === 'es' ? "Equipo infantil necesario, requisitos especiales, etc." : 
                           "Special requirements"}
                rows="3"
              ></textarea>
            </div>

            <div className="form-notice">
              <p>{t.formNotice1}</p>
              <p>{t.formNotice2}</p>
            </div>

            <button type="submit" className="btn btn-primary btn-large">
              {t.formSubmit}
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MainPage;